import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { apiDocumentRepository } from 'services/documents/ApiDocumentRepository';
import type { SigneeEntity } from 'services/documents/entities';
import { QueryKeys } from 'utils/queryKeys';

const getSigneeOptions = (accountId: number, inputValue: string) => {
  return apiDocumentRepository.getSignees(accountId, {
    searchText: inputValue,
    offset: 0,
    limit: 10,
  });
};

type Props = {
  accountId: number;
  inputValue: string;
  enabled: boolean;
};

export const useSigneeOptionsQuery = ({ accountId, inputValue, enabled }: Props) => {
  return useQuery<{ signees: SigneeEntity[] }>({
    queryKey: QueryKeys.getSignees(accountId, inputValue),
    queryFn: () => getSigneeOptions(accountId, inputValue),
    enabled,
    placeholderData: keepPreviousData,
  });
};
